export const actions = {
  // Viewer
  SET_NUM_PAGES: 'SET_NUM_PAGES',
  INCREMENT_PAGE: 'INCREMENT_PAGE',
  DECREMENT_PAGE: 'DECREMENT_PAGE',
  SCALE_UP: 'SCALE_UP',
  SCALE_DOWN: 'SCALE_DOWN',
  UPLOAD_FILE: 'UPLOAD_FILE',

  // Server
  REQUEST_ID_RECEIVED: 'REQUEST_ID_RECEIVED',
  ARCHIVE_ID_RECEIVED: 'ARCHIVE_ID_RECEIVED',

  GET_SIGNED_DOCS: 'GET_SIGNED_DOCS',
  GET_UNSIGNED_DOCS: 'GET_UNSIGNED_DOCS',

  // Upload state
  SET_UPLOAD_STATE: 'SET_UPLOAD_STATE',

  // Document actions
  UNSIGNED_DOC_EDIT_SUCCESSFUL: 'UNSIGNED_DOC_EDIT_SUCCESSFUL',
  UNSIGNED_DOC_DELETE_SUCCESSFUL: 'UNSIGNED_DOC_DELETE_SUCCESSFUL',

  // Last upload (for mapping editor step)
  SET_LAST_UPLOAD: 'SET_LAST_UPLOAD'
}
